import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PVG_PORTAL_KEY } from './core/types/projeto.types';
import { PreparePortalComponent } from './prepare-portal.component';
import { ManutencaoComponent } from './manutencao/manutencao.component';

const routes: Routes = [
  { path: '', component: PreparePortalComponent },
  // { path: '', redirectTo: 'manutencao', pathMatch: 'full' },
  { path: 'manutencao', component: ManutencaoComponent },
  {
    path: PVG_PORTAL_KEY,
    pathMatch: 'full',
    redirectTo: PVG_PORTAL_KEY + '/map',
  },
  { path: 'icad', pathMatch: 'full', redirectTo: 'icad/map' },
  { path: 'simples', pathMatch: 'full', redirectTo: 'simples/map' },
  {
    path: ':mode/map',
    loadChildren: () =>
      import('./modules/map/map.module').then((m) => m.MapModule),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'select-mode',
    loadChildren: () =>
      import('./modules/select-portal-mode/select-portal-mode.module').then(
        (m) => m.SelectPortalModeModule
      ),
  },
  {
    path: 'not-found/:city',
    loadChildren: () =>
      import('./modules/404/not-found.module').then((m) => m.NotFoundModule),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
